import { render, staticRenderFns } from "./DomainCard.vue?vue&type=template&id=777eca58"
import script from "./DomainCard.vue?vue&type=script&lang=js"
export * from "./DomainCard.vue?vue&type=script&lang=js"
import style0 from "./DomainCard.vue?vue&type=style&index=0&id=777eca58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports